import { BreadcrumbList, WithContext } from 'schema-dts';

import { BreadcrumbsItem } from '@/fo/util/map-product-data';

export const mapToJsonLd = (
  breadcrumbs: BreadcrumbsItem[],
  url?: {
    baseUrl: string;
    currentUrl: string;
  }
): WithContext<BreadcrumbList> => {
  const jsonLd: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => {
      let itemUrl = breadcrumb.href;
      if (url) {
        itemUrl = index
          ? index === breadcrumbs.length - 1
            ? url.currentUrl
            : `${url.baseUrl}/${breadcrumb.href}`
          : url.baseUrl;
      }

      return {
        '@type': 'ListItem',
        position: index + 1,
        name: index ? `⭐ ${breadcrumb.label}` : breadcrumb.label,
        item: itemUrl
      };
    })
  };

  return jsonLd;
};
